import axios from 'axios'

const {
  VUE_APP_API_SERVER,
  VUE_APP_API_SERVER_IE,
  VUE_APP_API_VISAS_ROUTE,
  VUE_APP_API_VISADOCS_ROUTE
} = process.env
const siteVar = window.siteVar
//console.log('siteVar = ',siteVar);
// `http://localhost:8002/api/visas/`
const getPageData = async (region) => {
 // console.log(`!!!${siteVar.referer === 'IE' ? VUE_APP_API_SERVER_IE : VUE_APP_API_SERVER}${VUE_APP_API_VISAS_ROUTE}`)
  const response = await axios.get(
    `${siteVar.referer === 'IE' ? VUE_APP_API_SERVER_IE : VUE_APP_API_SERVER}${VUE_APP_API_VISAS_ROUTE}/${region}`
  )
  return response.data
}

const getVisaData = (region, unid) => {
  return axios
    .get(
      `${siteVar.referer === 'IE' ? VUE_APP_API_SERVER_IE : VUE_APP_API_SERVER}${VUE_APP_API_VISAS_ROUTE}/info/${region}/${unid}`
    )
    .then(res => {
      return res.data
    })
}
const getVisaDetails = (region, country) => {
  return axios
    .get(
      `${siteVar.referer === 'IE' ? VUE_APP_API_SERVER_IE : VUE_APP_API_SERVER}${VUE_APP_API_VISAS_ROUTE}/details/${region}/${country}`
    )
    .then(res => {
      return res.data
    })
}

const getMainPage = (_site) => {
  return axios
    .get(
      `${siteVar.referer === 'IE' ? VUE_APP_API_SERVER_IE : VUE_APP_API_SERVER}${VUE_APP_API_VISADOCS_ROUTE}/${_site}`
    )
    .then(res => {
      return res.data
    })
}

const getVisaCountries = (_site) => {
  return axios
    .get(
      `${siteVar.referer === 'IE' ? VUE_APP_API_SERVER_IE : VUE_APP_API_SERVER}${VUE_APP_API_VISADOCS_ROUTE}/countries/${_site}`
    )
    .then(res => {
      return res.data
    })
}

/*
    app.get('/api/visadocs/:site', ctrl.getVisaMainPage);
    app.get('/api/visadocs/countries/:site', ctrl.getVisaCountriesList);
    app.get('/api/visadocs/country/:id', ctrl.getVisaCountry);
    app.get('/api/visadocs/country/:site/:webpagetitle', ctrl.getVisaTitleCountry);
 */

const getVisaCountry = (_site, _title) => {
  return axios
    .get(
      `${siteVar.referer === 'IE' ? VUE_APP_API_SERVER_IE : VUE_APP_API_SERVER}${VUE_APP_API_VISADOCS_ROUTE}/country/${_site}/${_title}`
    )
    .then(res => {
      return res.data
    })
}


export {
  getPageData,
  getVisaData,
  getVisaDetails,
  getMainPage,
  getVisaCountries,
  getVisaCountry
}
